import { PAGES } from '@/constants/pages';

export default {
  computed: {
    isPageOrdersRetail() {
      return this.$route.name === PAGES.orders.retail.name;
    },

    isPageOrdersDealer() {
      return this.$route.name === PAGES.orders.dealer.name;
    },

    isPageOrdersSupplier() {
      return this.$route.name === PAGES.orders.supplier.name;
    },

    isPageNewOrderZgi() {
      return this.$route.name === PAGES.orders.new_order.name && this.$route.query?.tab === 'zgi';
    },

    isDealerAmigo() {
      return this.$store?.getters?.['user/getDealer']?.parent_id === 1;
    },
  },
};
